<template>
  <div class="row">
    <div class="col col-md-4">
      <div class="card">
        <!--begin::Body-->
        <div class="card-body px-0">
          <!--begin::Member-->
          <div class="d-flex flex-column text-center px-9">
            <!--begin::Info-->
            <div class="text-center">
              <!--begin::Name-->
              <span id="edit_judicial_precedent_drawer_toggle" class="text-gray-800 fw-bold fs-4 mb-2">
                {{ currentEntity.name }}
              </span>
              <!--end::Name-->

              <div class="my-3">

                <div v-if="currentEntity.bank" class="badge badge-lg badge-light-primary d-inline mx-2">
                  {{ currentEntity.bank.name }}
                </div>

                <div v-if="currentEntity.affected_type" class="badge badge-lg badge-light-primary d-inline mx-2">
                  {{ currentEntity.affected_type.name }}
                </div>

                <div v-if="currentEntity.product" class="badge badge-lg badge-light-primary d-inline mx-2">
                  {{ currentEntity.product.name }}
                </div>

              </div>
              <!--begin::Position-->
              <span class="text-muted d-block fw-semibold mb-2">
<!--                {{ currentEntity.surname }}-->
              </span>

              <div class="fs-6">
                <div class="fw-bold mt-5">Estado actual</div>
                <div class="badge badge-lg" :class="{
                  'badge-success': currentEntity.is_favorable,
                  'badge-danger': !currentEntity.is_favorable,
                }">
                  {{ currentEntity.is_favorable ? 'Favorable' : 'Desfavorable' }}
                </div>
              </div>
            </div>
            <!--end::Info-->
          </div>
          <!--end::Member-->
        </div>
        <!--end::Body-->
      </div>
    </div>
    <div v-if="currentEntity.instances" class="col-12 col-md-8">
      <div class="row">
        <div class="col">
          <div class="card">
            <!--begin::Card head-->
            <div class="card-header card-header-stretch">
              <!--begin::Title-->
              <div class="card-title d-flex align-items-center">
                <i class="bi bi-list-ol fs-1 me-3 text-primary"></i>
                <h3 class="fw-bold m-0 text-gray-800">Instancias del procedimiento</h3>
              </div>
              <!--end::Title-->
            </div>
            <!--end::Card head-->

            <!--begin::Card body-->
            <div class="card-body">
              <!--begin::Timeline-->
              <div class="timeline">
                <template v-if="currentEntity.instances.length > 0">
                  <template v-for="(instance, index) in currentEntity.instances" :key="instance.hash">
                    <FirstInstance v-if="instance.type.id == INSTANCE_TYPES_AVAILABLE['FIRST']"
                                   :first-instance="instance"
                                   :instance="currentEntity"/>
                    <SecondInstance v-if="instance.type.id == INSTANCE_TYPES_AVAILABLE['SECOND']"
                                    :instance="currentEntity"
                                    :second-instance="instance"/>
                    <ThirdInstance v-if="instance.type.id == INSTANCE_TYPES_AVAILABLE['THIRD']"
                                   :instance="currentEntity"
                                   :third-instance="instance"/>
                  </template>
                </template>
              </div>
              <!--end::Timeline-->
            </div>
            <!--end::Card body-->
          </div>
          <!--end::Timeline-->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {useConfigStore} from '~/stores/config';
import Swal from "sweetalert2/dist/sweetalert2.js";
import {onBeforeMount, watch} from "vue";
import {storeToRefs} from "pinia";
import {useAuthStore} from "~/stores/auth";
import {useJudicialPrecedentsClientStore} from "~/stores/entities/client/judicialPrecedentClient";
import FirstInstance from "~/components/judicial-precedents/timeline/items/FirstInstance.vue";
import SecondInstance from "~/components/judicial-precedents/timeline/items/SecodInstance.vue";
import ThirdInstance from "~/components/judicial-precedents/timeline/items/ThirdInstance.vue";
import {INSTANCE_TYPES_AVAILABLE} from "~/types/interfaces/entitites/JudicialPrecedentInterface";

export default {
  name: 'JudicialPrecedentsDownload',
  components: {
    ThirdInstance,
    SecondInstance,
    FirstInstance
  },
  computed: {
    INSTANCE_TYPES_AVAILABLE() {
      return INSTANCE_TYPES_AVAILABLE
    }
  },
  setup() {
    // Importantísimo definir el "alias" a cada página
    definePageMeta({
      alias: '/sentencias/procedimientos/descargas/:hash/detalle',
    });
    const store = useAuthStore();
    const judicialPrecedentsClientStore = useJudicialPrecedentsClientStore();

    const configStore = useConfigStore();
    const {setPageTitle, setBreadcrumb} = configStore;
    setPageTitle('Descargar archivo');
    const data = [
      {name: 'Sentencias', link: '/sentencias/procedimientos/listado'},
      {name: 'Listado', link: '/sentencias/procedimientos/listado'},
      {name: 'Detalle', link: ''}
    ];
    setBreadcrumb(data);

    const {currentEntity, error} = storeToRefs(judicialPrecedentsClientStore);
    const {currentUser} = storeToRefs(store);
    const route = useRoute();

    watch(
        () => currentEntity.value,
        () => {
          setPageTitle(currentEntity.value.name);
        }
    );

    onBeforeMount(async () => {
      await judicialPrecedentsClientStore.view(route.params.hash);

      if (error.value?.status !== undefined) {
        Swal.fire({
          title: error.value.status,
          text: error.value.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Entendido",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semibold btn-light-danger",
          },
        });
      }
    });

    return {
      currentUser,
      currentEntity,
    }
  }
};
</script>

<style scoped></style>
